// NOTE: used to handle CRUD with RTK query
export const statusResponse = {
  DONE: { data: 'done' }
};
